module.exports = __webpack_public_path__ + "img/mobilelab_stopped.7e210b7c.svg";